export default __webpack_public_path__ + "static/media/f-2.94cd9451.jpg";